module.exports = {
          srcSet: "/_next/static/images/user3-146-91e8415854e70cd3fc2c3deec3444e55.jpg"+" 146w",
          images:[ {path: "/_next/static/images/user3-146-91e8415854e70cd3fc2c3deec3444e55.jpg",width: 146,height: 146}],
          src: "/_next/static/images/user3-146-91e8415854e70cd3fc2c3deec3444e55.jpg",
          toString:function(){return "/_next/static/images/user3-146-91e8415854e70cd3fc2c3deec3444e55.jpg"},
          
          width: 146,
          height: 146
        }